import 'dayjs/locale/pt';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/es';
import 'dayjs/locale/tl-ph';
import esIcon from 'assets/flags/es.svg?react';
import enIcon from 'assets/flags/gb.svg?react';
import tlIcon from 'assets/flags/ph.svg?react';
import ptIcon from 'assets/flags/pt.svg?react';

export enum ELanguages {
  En = 'en',
  Pt = 'pt',
  Es = 'es',
  Tl = 'tl',
}

export enum ENamespaceFiles {
  Countries = 'countries',
  Occupations = 'occupations',
}

export const APP_CONFIG = {
  LOCALE_DEFAULT: ELanguages.En,
  FALLBACK_LOCALE: ELanguages.En,
  LOCALES: {
    [ELanguages.En]: {
      key: ELanguages.En,
      label: 'English',
      flagIcon: enIcon,
      date: {
        locale: 'en-gb',
      },
    },
    [ELanguages.Pt]: {
      key: ELanguages.Pt,
      label: 'Português',
      flagIcon: ptIcon,
      date: {
        locale: 'pt',
      },
    },
    [ELanguages.Es]: {
      key: ELanguages.Es,
      label: 'Español',
      flagIcon: esIcon,
      date: {
        locale: 'es',
      },
    },
    [ELanguages.Tl]: {
      key: ELanguages.Tl,
      label: 'Filipino',
      flagIcon: tlIcon,
      date: {
        locale: 'tl-ph',
      },
    },
  },
};
